export const UPDATE_DETAILS = 'update-my-details';
